const baseURL = process.env.MIX_URL +  'ajax.php';
const baseUrlV4 = String(process.env.MIX_URL).replace(/\/+$/, '');
const CSRF = $('meta[name="csrf-token"]').attr('content');
const axios = require("axios");

const axiosGetHTML = async (params, BMCallBack = null) => {
    try
    {
        let response = await axios({
            method: 'get',
            timeout: 7000,
            baseURL,
            params,
            headers: {
                'X-CSRF-TOKEN': CSRF
            },
            responseType: 'text'
        });

        if (BMCallBack) {
            BMCallBack(response.data, response.status, null);
        }
    
    } catch ( err ) {
        if (BMCallBack) {
            BMCallBack(undefined, err.response?.status || 500);
        }
    }
  
};


const axiosGet = async (params, BMCallBack = null) => {
    try
    {
        let response = await axios({
            method: 'get',
            timeout: 7000,
            baseURL,
            params,
            headers: {
                'X-CSRF-TOKEN': CSRF
            },
            responseType: 'json'
        });

        if (BMCallBack) {
            BMCallBack(response.data, response.status, null);
        }
    
    } catch ( err ) {
        if (BMCallBack) {
            BMCallBack(undefined, err.response?.status || 500);
        }
    }
};

const axiosGetRest = async ({ endpoint = null, params = null, BMCallBack = null } = {}) => {
    try
    {
        const isApiV4 = endpoint && endpoint.startsWith('/api/v4/');
        const dynamicBaseURL = isApiV4 ? baseUrlV4 : baseURL;
        
        let response = await axios({
            method: 'get',
            timeout: 7000,
            baseURL : dynamicBaseURL + (endpoint ? endpoint : ''),
            params: params || {},
            headers: {
                'X-CSRF-TOKEN': CSRF
            },
            responseType: 'json'
        });

        const result = await Promise.resolve(response);
        if (typeof BMCallBack === 'function') {
            BMCallBack(result?.data?.data, result?.data?.status, result?.data?.message ?? null);
        }
        
    } catch ( err ) {
        if (typeof BMCallBack === 'function') {
            BMCallBack(null, err.response?.status || 500);
        }
        return null;
    }
};

const axiosPostRest = async ({ endpoint = null, BMCallBack = null, responseType = 'json', data = {} } = {}) => {
    try
    {
        const isFormData = data instanceof FormData;
        const isApiV4 = endpoint && endpoint.startsWith('/api/v4/');
        const dynamicBaseURL = isApiV4 ? baseUrlV4 : baseURL;

        const response = await axios({
            method: 'post', 
            timeout: 7000,
            baseURL: dynamicBaseURL + (endpoint ?? ''),
            data,
            headers: {
            'X-CSRF-TOKEN': CSRF,
            'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
            },
            responseType
        });
        
        const result = await Promise.resolve(response);

        if (typeof BMCallBack === 'function') {
            BMCallBack(result?.data?.data, result?.data?.status, result?.data?.message ?? null);
        }
    
    } catch ( err ) {
        if (typeof BMCallBack === 'function') {
            BMCallBack(err.response?.data || {}, err.response?.status || 500, err.response?.message);
        }
        return null;
    }
};


const axiosPut = async (data, BMCallBack, timeout = 7000) => {   

    try
    {
        let response = await axios({
            method: 'put', 
            timeout,
            baseURL,
            data,
            headers: {
                'X-CSRF-TOKEN': CSRF,
                'Content-Type': 'multipart/form-data'
            },
            responseType: 'json'
        });

        if (BMCallBack) {
            BMCallBack(response.data, response.status, null);
        }
    
    } catch ( err ) {
        if (BMCallBack) {
            BMCallBack(undefined, err.response?.status || 500);
        }
    }
};

const axiosSmartPut = async (data, BMCallBack) => {

    // Hack so that it goes to put
    data.append("method", "put");

    try
    {
        let response = await axios({
            method: 'post', // Put hack
            timeout: 7000,
            baseURL,
            data,
            headers: {
                'X-CSRF-TOKEN': CSRF,
                'Content-Type': 'multipart/form-data'
            },
            responseType: 'json'
        });

        if (BMCallBack) {
            BMCallBack(response.data, response.status, null);
        }
    
    } catch ( err ) {
        if (BMCallBack) {
            BMCallBack(undefined, err.response?.status || 500);
        }
    }
};

const axiosPost = async (data, BMCallBack) => {

    try
    {
        let response = await axios({
            method: 'post',
            timeout: 7000,
            baseURL,
            data,
            headers: {
                'X-CSRF-TOKEN': CSRF,
                'Content-Type': 'multipart/form-data'
            },
            responseType: 'json'
        });

        if (BMCallBack) {
            BMCallBack(response.data, response.status, null);
        }
    
    } catch ( err ) {
        if (BMCallBack) {
            BMCallBack(undefined, err.response?.status || 500);
        }
    }
};

const axiosDeleteRest = async ({ endpoint = null, params = null, BMCallBack = null } = {}) => {

    try
    {
        let response = await axios({
            method: 'delete',
            timeout: 7000,
            baseURL: baseURL + (endpoint ? endpoint : ''),
            data: params || {},
            headers: {
                'X-CSRF-TOKEN': CSRF,
                'Content-Type': 'application/json'
            },
            responseType: 'json'
        });

        const result = await Promise.resolve(response);

        if (typeof BMCallBack === 'function') {
            BMCallBack(result?.data?.data, result?.data?.status, result?.data?.message ?? null);
        }        
    
    } catch ( err ) {
        if (typeof BMCallBack === 'function') {
            BMCallBack(null, err.response?.status || 500);
        }

        return null;
    }
};

const axiosPutRest = async ({ endpoint = null, params = null, BMCallBack = null, responseType = 'json' } = {}) => {
    try
    {
        let response = await axios({
            method: 'put',
            timeout: 7000,
            baseURL: baseURL + (endpoint ?? ''),
            data: params,
            headers: {
                'X-CSRF-TOKEN': CSRF,
                'Content-Type': params instanceof FormData ? 'multipart/form-data' : 'application/json'
            },
            responseType
        });

        const result = await Promise.resolve(response);

        if (typeof BMCallBack === 'function') {
            BMCallBack(result?.data?.data, result?.data?.status, result?.data?.message ?? null);
        }       

        return result?.data?.data;
    
    } catch ( err ) {
        if (typeof BMCallBack === 'function') {
            BMCallBack(null, err.response?.status ?? 500);
        }
        return null;
    }
};

export { 
    axiosGet,
    axiosGetHTML,
    axiosPut,
    axiosSmartPut,
    axiosPost,
    axiosPostRest,
    axiosGetRest,
    axiosDeleteRest,
    axiosPutRest
};

